/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casemanagement_Categoriestab2Inputs */

const en_settings_casemanagement_categoriestab2 = /** @type {(inputs: Settings_Casemanagement_Categoriestab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories`)
};

/**
* | output |
* | --- |
* | "Categories" |
*
* @param {Settings_Casemanagement_Categoriestab2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casemanagement_categoriestab2 = /** @type {((inputs?: Settings_Casemanagement_Categoriestab2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casemanagement_Categoriestab2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casemanagement_categoriestab2(inputs)
});
export { settings_casemanagement_categoriestab2 as "settings_caseManagement_categoriesTab" }